import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOverride = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_994_6141",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_994_6141)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.40026 4C7.40571 4 6.60017 4.80554 6.60017 5.80009V12.1004C6.60017 13.0949 7.40571 13.9005 8.40026 13.9005H11.1004V16.6006C11.1004 17.5844 11.9167 18.4007 12.9005 18.4007H19.2008C20.1846 18.4007 21.0009 17.5844 21.0009 16.6006V10.3003C21.0009 9.3165 20.1846 8.50021 19.2008 8.50021H16.5006V5.80009C16.5006 4.80554 15.6951 4 14.7006 4H8.40026ZM16.5006 10.3003H19.2008V16.6006H12.9005V13.9005H14.7006C15.6951 13.9005 16.5006 13.0949 16.5006 12.1004V10.3003ZM3 13.9005V17.5006C3 18.4844 3.81628 19.3007 4.80009 19.3007H7.50021V21.1008L10.2003 18.4007L7.50021 15.7006V17.5006H4.80009V13.9005H3Z",
			fill: "currentColor"
		})
	})]
});
export default SvgOverride;
